/**
 * The route explorer's frame. Its scrim died with the conversion - a bare
 * antd Modal now hosts the same .route-explorer card, which brings its own
 * chrome, and the explorer inside it is React (RouteExplorerView).
 *
 * The dialog conditional-mounts, so the explorer is built fresh on every open
 * exactly as the old scrim rebuilt it: its nav selection survives via
 * localStorage, its knobs deliberately reset.
 */

import { Modal } from 'antd'
import type { Journal } from '../../learn/Journal'
import { RouteExplorerView } from './RouteExplorerView'

export function RoutesDialog({
  journal,
  onClose,
}: {
  journal: Journal | null
  onClose: () => void
}) {
  return (
    <Modal
      open
      onCancel={onClose}
      footer={null}
      title={null}
      closable={false}
      className="bare-modal"
      width="min(1180px, 96vw)"
      centered
    >
      <div style={{ height: 'min(780px, 88vh)', display: 'flex' }}>
        <RouteExplorerView journal={journal} />
      </div>
    </Modal>
  )
}
